const AgencePresenter = (props) =>{
    let agence_data = props.agence;

    return(
        <span key={agence_data.code} style={{backgroundColor: "grey", fontWeight: "bold", padding: "10px 8px", borderRadius: "10px", margin: "2px", color:"white" }}>{agence_data.code}</span>
    )
}

export default AgencePresenter;